<template>
<div class="jzbWrap">
  <el-tabs v-model="activeTab"  @tab-click="handleClick">
      <el-tab-pane label="个人绑定" name="person" v-if="jzb_attribute === 'private' || jzb_attribute === 'private-public'">
        <userbing v-if="person"  :type="2"></userbing>
      </el-tab-pane>
      <el-tab-pane label="企业绑定" name="business" v-if="jzb_attribute === 'public' || jzb_attribute === 'private-public'">
        <userbing v-if="business" :type="1"></userbing>
      </el-tab-pane>
  </el-tabs>
</div>
</template>

<script>
import userbing from './userBinding'
export default {
  components: {userbing},
  data () {
    return {
      jzb_attribute: '',
      activeTab: 'person',
      business: false,
      person: true,
    }
  },
  created(){
    // 获取见证宝账号属性 对公 public 还是 对私 private private-public 两个同时存在
    const value = localStorage.getItem('jzb_attribute');
    this.jzb_attribute = value;
    this.activeTab = value === 'public' ? 'business' : 'person';
    this.business = value === 'public' ? true : false;
    this.person = value === 'private' || value === 'private-public' ? true : false;
  },
  methods: {
    handleClick (tab) {
      if (tab.name === 'business') {
        this.business = true
      }
      if (tab.name === 'person') {
        this.person = true
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/user/bindingTab.vue